export enum ProjectStructureType {
    Application = 'application',
    Template = 'template',
    Module = 'module',
}
